import * as swcHelpers from '@swc/helpers';
import { format, isSameMinute as isSameMinute$1, isSameDay as isSameDay$1, isBefore as isBefore$1, isWithinInterval, eachDayOfInterval, addYears, addMonths, addWeeks, addDays, parseISO, isValid } from 'date-fns';

// TODO: refactor to use `formatDate`
const dateToDayAndNumberString = (date)=>format(date, 'EEEE d')
;
const dateToDayNumberMonthYearString = (date)=>format(date, 'EEEE d MMMM, yyyy')
;
const dateToLocalTime = (date, timeFormat = '24h')=>timeFormat === 'amPm' ? format(date, 'h:mma') : format(date, 'H:mm')
;
const datesToLocalTimeSpan = (from, until, timeFormat = '24h')=>`${dateToLocalTime(from, timeFormat)} - ${dateToLocalTime(until, timeFormat)}`
;
/**
 * @deprecated Use dateToLocalTime
 */ const dateToShortTime = (date)=>dateToLocalTime(date)
;
const isSameMinute = (date1, date2)=>isSameMinute$1(date1, date2)
;
const isSameDay = (date1, date2)=>isSameDay$1(date1, date2)
;
const isBefore = (date1, date2)=>isBefore$1(date1, date2)
;
const isDateBefore = (date1, date2)=>new Date(date1).setHours(0, 0, 0, 0) < new Date(date2).setHours(0, 0, 0, 0)
;
const sortDesc = (left, right)=>right.getTime() - left.getTime()
;
const isWithinTimeSpan = (date, start, end)=>isWithinInterval(date, {
        start,
        end
    })
;
/**
 * Serialize a Date as a local ISO8601 datetime string. Like Date.prototype.toISOString,
 * but in the local timezone and without the timezone offset.
 */ const toLocalDateTime = (date)=>format(date, "yyyy-MM-dd'T'HH:mm:ss")
;
/**
 * Serialize a Date as a local ISO8601 datetime string. Like Date.prototype.toISOString,
 * but in the local timezone and with the timezone offset.
 */ const toLocalDateTimeTimeZone = (date)=>format(date, "yyyy-MM-dd'T'HH:mm:ss:xxx")
;
/**
 * Serialize a Date as a local ISO8601 date string. Like Date.prototype.toISOString,
 * but in the local timezone and just the date, no time or timezone offset.
 */ const toLocalDate = (date)=>format(date, 'yyyy-MM-dd')
;
const eachDay = (start, end)=>eachDayOfInterval({
        start,
        end
    })
;
const shiftDate = (date, period, amount = 1)=>{
    switch(period){
        case 'day':
            return addDays(date, amount);
        case 'week':
            return addWeeks(date, amount);
        case 'month':
            return addMonths(date, amount);
        case 'year':
            return addYears(date, amount);
    }
};
const getDateListFromDate = (date, size = 7)=>eachDay(date, shiftDate(date, 'day', size - 1))
;
const pattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
const parseLocalDateTime = (input)=>{
    if (!pattern.test(input)) {
        throw new Error(`Invalid local datetime string: ${input}`);
    }
    return parseISO(input);
};
const minutesToHM = (value, locale)=>{
    const baseSettings = {
        style: 'unit',
        notation: 'compact',
        compactDisplay: 'short'
    };
    if (value === 0) {
        return Intl.NumberFormat(locale, swcHelpers.objectSpread({}, baseSettings, {
            unit: 'minute'
        })).format(value);
    }
    const hours = Math.floor(value / 60);
    const minutes = Math.floor(value % 60);
    const hDisplay = hours > 0 ? Intl.NumberFormat(locale, swcHelpers.objectSpread({}, baseSettings, {
        unit: 'hour'
    })).format(hours) : '';
    const mDisplay = minutes > 0 ? Intl.NumberFormat(locale, swcHelpers.objectSpread({}, baseSettings, {
        unit: 'minute'
    })).format(minutes) : '';
    return `${hDisplay} ${mDisplay}`.trim();
};
/**
 * Checks if the given start and end dates form a valid range.
 * A range is considered valid if the start date is not after the end date
 * and the end date is not before the start date.
 *
 * @param {Date} startDate - The start date of the range
 * @param {Date} endDate - The end date of the range
 * @returns {boolean} - True if the date range is valid, false otherwise
 */ const isValidDateRange = (startDate, endDate)=>{
    if (!isValid(startDate) || !isValid(endDate)) {
        return false;
    }
    return !isBefore(endDate, startDate);
};

export { dateToDayAndNumberString, dateToDayNumberMonthYearString, dateToLocalTime, dateToShortTime, datesToLocalTimeSpan, eachDay, getDateListFromDate, isBefore, isDateBefore, isSameDay, isSameMinute, isValidDateRange, isWithinTimeSpan, minutesToHM, parseLocalDateTime, shiftDate, sortDesc, toLocalDate, toLocalDateTime, toLocalDateTimeTimeZone };
//# sourceMappingURL=date-utils.js.map
